import React from 'react';
import { Card, Table, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyCheckAlt, faExternalLinkAlt, faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const PagosRelacionados = ({ pagos, totalFactura, tipoFactura = "emitida" }) => {
    if (!pagos || pagos.length === 0) {
        return null;
    }

    const formatNumberMX = (value) => {
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
    };

    const sumaPagos = pagos.reduce((acc, pago) => acc + (parseFloat(pago.dImpPagado) || 0), 0);
    const totalFact = parseFloat(totalFactura) || 0;
    // We round to 2 decimals to avoid floating point issues
    const restante = Math.round((totalFact - sumaPagos) * 100) / 100;
    const isPagada = totalFact > 0 && restante <= 0;

    const rutaVisualizacion = tipoFactura === "recibida" 
        ? "/contabilidad/centro-xml/pagos-recibidos/visualizacion/" 
        : "/contabilidad/centro-xml/pagos-emitidos/visualizacion/";

    return (
        <Card className="mb-4 border-0 shadow-sm">
            <Card.Header className="bg-light border-0 py-3 d-flex align-items-center">
                <FontAwesomeIcon icon={faMoneyCheckAlt} className="text-primary me-2" />
                <h6 className="m-0 fw-bold text-dark">Complementos de Pago Relacionados</h6>
            </Card.Header>
            <Card.Body className="p-0">
                <div className="p-3 bg-white border-bottom">
                    {isPagada ? (
                        <Alert variant="success" className="m-0 py-2 d-flex align-items-center" style={{ fontSize: '0.9rem' }}>
                            <FontAwesomeIcon icon={faCheckCircle} className="me-2 fs-5" />
                            <span><strong>¡Factura Pagada!</strong> La suma de los pagos cubre por completo el total de la factura.</span>
                        </Alert>
                    ) : (
                        <Alert variant="info" className="m-0 py-2 d-flex align-items-center" style={{ fontSize: '0.9rem' }}>
                            <FontAwesomeIcon icon={faInfoCircle} className="me-2 fs-5" />
                            <span>Aún resta por pagar: <strong>{formatNumberMX(restante > 0 ? restante : 0)}</strong> de un total de {formatNumberMX(totalFact)}</span>
                        </Alert>
                    )}
                </div>
                <div className="table-responsive">
                    <Table hover responsive className="m-0 align-middle" style={{ fontSize: '0.85rem' }}>
                        <thead className="bg-light">
                            <tr>
                                <th className="border-0 px-4">UUID del Pago</th>
                                <th className="border-0">Fecha de Pago</th>
                                <th className="border-0 text-center">Parcialidad</th>
                                <th className="border-0 text-end px-4">Importe Pagado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pagos.map((pago, idx) => (
                                <tr key={idx}>
                                    <td className="px-4">
                                        <Link 
                                            to={`${rutaVisualizacion}${pago.idFacturaPagoEmitido}`} 
                                            target="_blank"
                                            className="text-primary text-decoration-none d-flex align-items-center"
                                        >
                                            {pago.vUUIDFactura}
                                            <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-2" style={{ fontSize: '0.7rem' }} />
                                        </Link>
                                    </td>
                                    <td>
                                        {pago.dFechaEmision ? new Date(pago.dFechaEmision).toLocaleDateString('es-MX', {
                                            year: 'numeric', month: '2-digit', day: '2-digit',
                                            hour: '2-digit', minute: '2-digit'
                                        }) : '-'}
                                    </td>
                                    <td className="text-center">{pago.iNumeroParcialidad || 1}</td>
                                    <td className="text-end text-success fw-bold px-4">{formatNumberMX(pago.dImpPagado || 0)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default PagosRelacionados;
